<div class="d-flex flex-row justify-content-between">
	<h1>{{ title.getTitle() }}</h1>
	<div id="informativeContent">
		<div id="actionElements">
			<input type="button" id="btnNewOption" *ngIf="this.canCreateEditDelete" value="New Help File"
				(click)="openModal(0)" class="btn btn-save btn-lg mr-2" />
			<input type="button" id="btnNewVideo" *ngIf="this.canCreateEditDelete" value="New Help Video"
				(click)="openModal(0, 0)" class="btn btn-save btn-lg" />
		</div>
	</div>
</div>

<hr />

<pcg-table #table [multipleSearch]="false" [pcgSort]="[['moduleName', 'asc'], ['name', 'asc']]"
	dataSource="api/HelpFiles/HelpFiles/GetHelpFilesList" [columnDefs]="columns" [canExactMatchSearch]="false">

		<ng-container cdkColumnDef="helpFileId">
			<th class="text-center" cdk-header-cell *cdkHeaderCellDef>{{ columns.get('helpFileId').displayName }}</th>
			<td class="text-center" cdk-cell *cdkCellDef="let row" data-label="Edit">
				<pcg-edit-link *ngIf="canCreateEditDelete" (click)="openModal(row.helpFileId, row.videoId)">
					<img style="width: 25px; cursor: pointer" src="assets/images/actions/edit.png" />
				</pcg-edit-link>
			</td>
		</ng-container>

		<ng-container cdkColumnDef="name">
			<th cdk-header-cell pcg-sort-header *cdkHeaderCellDef>{{ columns.get('name').displayName }}</th>
			<td cdk-cell *cdkCellDef="let row" data-label="Name">
				<a target="_blank" *ngIf="!row.videoId" [href]="'/Uploads/HelpFiles/' + row.fileName">{{ row.name }}</a>
				<span *ngIf="row.videoId">
					<img style="width: 20px; cursor: pointer" class="pr-1" src="assets/images/informational/movie.svg" />
					<a target="_blank" [href]="'/help/help-video/' + row.helpFileId">{{ row.name }}</a>
				</span>
			</td>
		</ng-container>

		<ng-container cdkColumnDef="moduleName">
			<th cdk-header-cell pcg-sort-header *cdkHeaderCellDef>{{ columns.get('moduleName').displayName }}</th>
			<td cdk-cell *cdkCellDef="let row" data-label="Module">{{ row.moduleName }}</td>
		</ng-container>

		<ng-container cdkColumnDef="description">
			<th cdk-header-cell pcg-sort-header *cdkHeaderCellDef>{{ columns.get('description').displayName }}</th>
			<td cdk-cell *cdkCellDef="let row" data-label="Description">
				<pcg-ellipsis [size]="250" [data]="row.description"></pcg-ellipsis>
			</td>
		</ng-container>

		<ng-container *ngIf="this.canCreateEditDelete" cdkColumnDef="delete">
			<th class="text-center" cdk-header-cell *cdkHeaderCellDef>Delete</th>
			<td class="text-center" cdk-cell *cdkCellDef="let row" data-label="Delete">
				<pcg-delete-button [table]="table" [confirmMessage]="'Are you sure you want to delete this?'"
					url="api/HelpFiles/HelpFiles/DeleteHelpFile" [id]="row.helpFileId"></pcg-delete-button>
			</td>
		</ng-container>
	</pcg-table>

	<ng-template #helpfile let-modal>
		<form [formGroup]="formGroup" pcgSubmitUrl="api/HelpFiles/HelpFiles/SaveFile" (messageSuccess)="modal.dismiss(); this.table.ajaxReload()">
			<div class="modal-header">
				<h5 class="modal-title" id="modal-basic-title">Help File</h5>
				<button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">
				<div class="row">
					<pcg-control-group class="col-md-6" label="Name">
						<input pcgControlRef formControlName="name" class="form-control" type="text" />
					</pcg-control-group>
					<pcg-control-group class="col-md-6" label="Module">
						<pcg-select pcgControlRef [multiple]="false" dataSource="api/Select/HelpModules"
							formControlName="module" placeholder="Select a Module"></pcg-select>
					</pcg-control-group>
				</div>

				<div class="row">
					<pcg-control-group class="col-md-12" label="Description">
						<textarea pcgControlRef formControlName="description" class="form-control"></textarea>
					</pcg-control-group>
				</div>

				<div *ngIf="this.formGroup.controls['helpFileId'].value === 0" class="row">
					<pcg-control-group class="col-md-12" label="Help File Upload">
						<label>This is the Help file that all users will be able to see and access.</label>
						<pcg-file-upload pcgControlRef formControlName="file" type="file"></pcg-file-upload>
					</pcg-control-group>
				</div>

				<div *ngIf="this.formGroup.controls['helpFileId'].value !== 0" class="row">
					<pcg-control-group class="col-md-12" label="Overwrite Help File (optional)">
						<label>This is the Help file that all users will be able to see and access.</label>
						<pcg-file-upload pcgControlRef formControlName="file" type="file"></pcg-file-upload>
					</pcg-control-group>
				</div>

				<div *ngIf="this.formGroup.controls['helpFileId'].value === 0" class="row">
					<pcg-control-group class="col-md-12" label="Source File Upload">
						<label>This is the file that will be used to make edits/updates.</label>
						<pcg-file-upload pcgControlRef formControlName="sourceFile" type="file"></pcg-file-upload>
					</pcg-control-group>
				</div>

				<div *ngIf="this.formGroup.controls['helpFileId'].value !== 0" class="row">
					<pcg-control-group class="col-md-12" label="Overwrite Source File (optional)">
						<label>This is the file that will be used to make edits/updates.</label>
						<pcg-file-upload pcgControlRef formControlName="sourceFile" type="file"></pcg-file-upload>
					</pcg-control-group>
				</div>

				<div *ngIf="this.formGroup.controls['helpFileId'].value !== 0 && this.formGroup.controls['sourceFileName'].value !== null" class="row">
					<div class="col-md-12" label="Download Source File">
						<a target="_blank" [href]="'/Uploads/HelpFiles/' + this.formGroup.controls['sourceFileName'].value">Download Source File</a>
					</div>
				</div>
			</div>

			<div class="modal-footer">
				<button type="button" class="btn btn-cancel btn-lg" (click)="modal.dismiss()">Cancel</button>
				<button type="submit" class="btn btn-save btn-lg">Save</button>
			</div>

		</form>
	</ng-template>

	<ng-template #helpvideo let-modal>
		<form [formGroup]="formGroup" pcgSubmitUrl="api/HelpFiles/HelpFiles/SaveFile" (messageSuccess)="modal.dismiss(); this.table.ajaxReload()">
			<div class="modal-header">
				<h5 class="modal-title" id="modal-basic-title">Help Video</h5>
				<button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">
				<div class="row">
					<pcg-control-group class="col-md-6" label="Name">
						<input pcgControlRef formControlName="name" class="form-control" type="text" />
					</pcg-control-group>

					<pcg-control-group class="col-md-6" label="Module">
						<pcg-select pcgControlRef [multiple]="false" dataSource="api/Select/HelpModules"
							formControlName="module" placeholder="Select a Module"></pcg-select>
					</pcg-control-group>
				</div>

				<div class="row">
					<pcg-control-group class="col-md-12" label="Description">
						<textarea pcgControlRef formControlName="description" class="form-control"></textarea>
					</pcg-control-group>
				</div>

				<div class="row">
					<pcg-control-group class="col-md-12" label="Video ID"
						labelTooltip="Input the Vimeo video ID here. This ID can be found in the published Vimeo video URL.">
						<input pcgControlRef formControlName="videoId" class="form-control" type="text" />
					</pcg-control-group>
				</div>

			</div>

			<div class="modal-footer">
				<button type="button" class="btn btn-cancel btn-lg" (click)="modal.dismiss()">Cancel</button>
				<button type="submit" class="btn btn-save btn-lg">Save</button>
			</div>

		</form>
	</ng-template>
